import React from "react";
import { DatePickerInput, DatePickerInputProps } from "@mantine/dates";

import styles from "@scss/custom-components/form-fields-dropdowns.module.scss";

interface CustomDatePickerInputProps extends DatePickerInputProps {}

export const CustomDatePickerInput: React.FC<CustomDatePickerInputProps> = ({
  variant = "default",
  classNames = {},
  ...props
}) => {
  const variantDropdownClasses: Record<string, string> = {
    default: styles["dropdown--default"],
    dark: styles["dropdown--dark"],
    darker: styles["dropdown--darker"],
    sky: styles["dropdown--sky"],
  };

  const customDropdownClass = variantDropdownClasses[variant] || "";

  return (
    <DatePickerInput
      variant={variant}
      classNames={{
        ...classNames,
        calendarHeader: styles.calendarHeader,
        calendarHeaderControl: styles.calendarHeaderControl,
        calendarHeaderLevel: styles.calendarHeaderLevel,
        weekday: styles.weekday,
        day: styles.day,
        monthsListControl: styles.month,
        yearsListControl: styles.year,
      }}
      popoverProps={{
        classNames: {
          dropdown: customDropdownClass,
        },
      }}
      {...props}
    />
  );
};
